module.exports = __webpack_public_path__ + "static/media/photo-description.8677e94d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshots/photo-description.png
// module id = 217
// module chunks = 27